/* uwelle® · Ficha del ritual completo · 28 sep 2026
   Selector de variante (uBouclé: Gelée o Mousse), «Arma el tuyo», comprar
   ahora, entrega estimada y barra de compra. Sin dependencias. Si este
   archivo no carga, la página se sigue pudiendo comprar: el botón principal
   es el formulario nativo del tema.
   30 sep 2026 · La galería es la de la ficha de producto y la mueven
   uwelle-ficha.js y uwelle-ficha-zoom.js; su código salió de aquí. */
(function () {
  'use strict';
  function fmt(c) { return '$ ' + Math.round(c / 100).toLocaleString('en-US'); }
  function lista(a) { return a.length < 2 ? a.join('') : a.slice(0, -1).join(', ') + ' y ' + a[a.length - 1]; }

  function init(root) {
    if (root.__uwr) return; root.__uwr = true;
    var umbral = +root.dataset.umbral || 69900, tarifa = +root.dataset.tarifa || 9900;
    var formId = root.dataset.form;
    var vars = []; try { vars = JSON.parse(root.querySelector('[data-uwr-variantes]').textContent); } catch (e) {}
    var vid = root.querySelector('[data-uwr-vid]');
    var cur = vars.filter(function (x) { return vid && String(x.id) === vid.value; })[0] || vars[0];

    /* La galería es la de la ficha de producto desde el 30 sep 2026: la mueven
       uwelle-ficha.js y uwelle-ficha-zoom.js. Al cambiar de variante, la fila
       de envases y su miniatura se actualizan abajo, por `data-var`. */

    /* ── selector de variante ── */
    function setVar(v) {
      if (!v) return; cur = v;
      if (vid) vid.value = v.id;
      root.querySelectorAll('[data-uwr-now]').forEach(function (e) { e.textContent = fmt(v.p); });
      root.querySelectorAll('[data-uwr-was]').forEach(function (e) {
        var h = e.querySelector('.visually-hidden'); e.textContent = fmt(v.c); if (h) e.prepend(h);
      });
      var pct = root.querySelector('[data-uwr-pct]'); if (pct) pct.innerHTML = v.pct;
      var ah = root.querySelector('[data-uwr-ahorro]'); if (ah) ah.textContent = fmt(v.c - v.p);
      var tot = root.querySelector('[data-uwr-total]');
      if (tot) tot.textContent = fmt(v.p) + ' · ' + (v.p >= umbral ? 'envío gratis' : 'más envío de ' + fmt(tarifa));
      var totRow = root.querySelector('[data-uwr-tot]'); if (totRow) totRow.hidden = v.p >= umbral;
      var vt = root.querySelector('[data-uwr-vt]'); if (vt) vt.textContent = String(v.t).split(' · ').pop();
      root.querySelectorAll('[data-var]').forEach(function (e) {
        var off = e.getAttribute('data-var') !== v.t;
        if (e.classList.contains('uwr-step')) { e.classList.toggle('is-obien', off); return; }
        e.classList.toggle('is-off', off);
      });
      root.querySelectorAll('.uwr-sel__o').forEach(function (o) {
        var i = o.querySelector('input'); o.classList.toggle('is-on', i && String(i.value) === String(v.id));
      });
      root.querySelectorAll('button[form="' + formId + '"],.uwr-cta button[type=submit],[data-uwr-ahora]').forEach(function (b) { b.disabled = !v.a; });
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
      arma();
    }
    root.querySelectorAll('.uwr-sel__o input').forEach(function (i) {
      i.addEventListener('change', function () { setVar(vars.filter(function (x) { return String(x.id) === i.value; })[0]); });
    });

    /* ── comprar ahora: agrega el ritual y va directo al pago ── */
    var rutaRaiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var ahora = root.querySelector('[data-uwr-ahora]');
    if (ahora && vid) {
      var ahoraTxt = ahora.textContent;
      ahora.hidden = false;
      ahora.addEventListener('click', function () {
        ahora.disabled = true; ahora.textContent = 'Un momento…';
        fetch(rutaRaiz + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +vid.value, quantity: 1 }] })
        }).then(function (r) { if (!r.ok) throw r; location.href = rutaRaiz + 'checkout'; })
          .catch(function () { ahora.disabled = !(cur && cur.a); ahora.textContent = ahoraTxt; });
      });
      /* Al volver con «atrás» desde el pago, el botón no se queda en «Un momento…». */
      window.addEventListener('pageshow', function (e) { if (e.persisted) { ahora.disabled = !(cur && cur.a); ahora.textContent = ahoraTxt; } });
    }

    /* ── entrega estimada ──
       Regla publicada en Envíos y entregas: pedidos confirmados antes de las
       14:00 h del centro de México empiezan a prepararse ese día; en total, de
       4 a 7 días contando de lunes a sábado. Se cuentan días hábiles (sin
       domingos ni días de descanso obligatorio) desde el día en que empieza la
       preparación. Si algo falla, se queda el texto del servidor. */
    var eta = root.querySelector('[data-uwr-eta]');
    if (eta) { try { eta.textContent = entrega(+eta.dataset.min || 4, +eta.dataset.max || 7); } catch (e) {} }
    function entrega(dMin, dMax) {
      var parts = {};
      new Intl.DateTimeFormat('en-US', { timeZone: 'America/Mexico_City', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
      var d = new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day));
      var festivos = ['2026-11-16', '2026-12-25', '2027-01-01', '2027-02-01', '2027-03-15', '2027-05-01', '2027-09-16', '2027-11-15', '2027-12-25'];
      function habil(x) { return x.getUTCDay() !== 0 && festivos.indexOf(x.toISOString().slice(0, 10)) < 0; }
      function sig(x) { var y = new Date(x); y.setUTCDate(y.getUTCDate() + 1); return y; }
      if (!habil(d) || +parts.hour >= 14) { d = sig(d); while (!habil(d)) d = sig(d); }
      function suma(x, n) { var y = new Date(x); while (n > 0) { y = sig(y); if (habil(y)) n--; } return y; }
      var a = suma(d, dMin), b = suma(d, dMax);
      var dia = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'], mes = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
      var fa = dia[a.getUTCDay()] + ' ' + a.getUTCDate() + (a.getUTCMonth() !== b.getUTCMonth() ? ' de ' + mes[a.getUTCMonth()] : '');
      var fb = dia[b.getUTCDay()] + ' ' + b.getUTCDate() + ' de ' + mes[b.getUTCMonth()];
      return 'con entrega estimada entre el ' + fa + ' y el ' + fb;
    }

    /* ── arma el tuyo ── */
    var sec = root.querySelector('[data-uwr-arma]');
    var tiles = sec ? [].slice.call(sec.querySelectorAll('.uwr-tile')) : [];
    var acta = sec && sec.querySelector('[data-uwr-acta]');
    var ctaTxt = acta ? acta.textContent : '';
    /* Vivos: los gestos de la variante elegida que se pueden comprar. Un gesto
       agotado se queda a la vista, pero no suma ni se agrega. */
    function vivos() { return tiles.filter(function (t) { return !t.classList.contains('is-off') && !t.querySelector('input').disabled; }); }
    function arma() {
      if (!sec) return;
      var ts = vivos();
      var sel = ts.filter(function (t) { return t.querySelector('input').checked; });
      var off = ts.filter(function (t) { return !t.querySelector('input').checked; });
      ts.forEach(function (t) { t.classList.toggle('is-on', t.querySelector('input').checked); });
      var sub = sel.reduce(function (a, t) { return a + (+t.dataset.p); }, 0);
      var miss = off.reduce(function (a, t) { return a + (+t.dataset.p); }, 0);
      var lines = sec.querySelector('[data-uwr-lines]'), msg = sec.querySelector('[data-uwr-msg]');
      var fix = sec.querySelector('[data-uwr-fix]'), tot = sec.querySelector('[data-uwr-atotal]'), lbl = sec.querySelector('[data-uwr-lbl]');
      var h = sel.map(function (t) { return '<div class="ln"><span>' + t.dataset.n + '</span><span>' + fmt(+t.dataset.p) + '</span></div>'; }).join('');
      if (off.length === 0) {
        h += '<div class="ln"><span>Los ' + ts.length + ' por separado</span><s>' + fmt(sub) + '</s></div><div class="ln"><span>Envío</span><span>' + (cur.p >= umbral ? 'Gratis' : fmt(tarifa)) + '</span></div>';
        lines.innerHTML = h; lbl.textContent = 'El ritual completo'; tot.textContent = fmt(cur.p);
        var hoy = sub - cur.p, reg = cur.c - cur.p;
        msg.innerHTML = (hoy > 0 ? 'Juntos cuestan <b>' + fmt(hoy) + ' menos</b> que sumarlos hoy' + (reg > hoy ? ', y <b>' + fmt(reg) + ' menos</b> que a precio regular.' : '.') : '');
        fix.hidden = true; acta.textContent = ctaTxt; acta.dataset.modo = 'ritual';
      } else if (sel.length === 0) {
        lines.innerHTML = ''; lbl.textContent = 'Total'; tot.textContent = fmt(0);
        msg.textContent = 'Elige al menos un gesto.'; fix.hidden = false; fix.textContent = 'Volver al ritual completo';
        acta.textContent = 'Elige un gesto'; acta.dataset.modo = 'nada';
      } else {
        var ship = sub < umbral ? tarifa : 0;
        h += '<div class="ln"><span>Envío</span><span>' + (ship ? fmt(ship) : 'Gratis') + '</span></div>';
        lines.innerHTML = h; lbl.textContent = 'Total'; tot.textContent = fmt(sub + ship);
        /* Se comparan totales a pagar: envío incluido en ambos lados. */
        var ritTot = cur.p + (cur.p >= umbral ? 0 : tarifa);
        var diff = ritTot - (sub + ship);
        msg.innerHTML = diff > 0
          ? 'Por <b>' + fmt(diff) + ' más</b>' + (ship && ritTot === cur.p ? ', con el envío ya incluido,' : '') + ' te llevas el ritual completo: sumas ' + lista(off.map(function (t) { return t.dataset.n; })) + ' (' + fmt(miss) + ' por separado).'
          : 'Con estos gestos te conviene el ritual completo.';
        fix.hidden = false; fix.textContent = diff > 0 ? 'Completar el ritual por ' + fmt(diff) + ' más' : 'Llevar el ritual completo';
        acta.textContent = 'Agregar ' + sel.length + (sel.length > 1 ? ' gestos' : ' gesto') + ' al carrito'; acta.dataset.modo = 'sueltos';
      }
    }
    tiles.forEach(function (t) { t.querySelector('input').addEventListener('change', arma); });
    if (sec) {
      sec.querySelector('[data-uwr-fix]').addEventListener('click', function () {
        vivos().forEach(function (t) { t.querySelector('input').checked = true; }); arma();
      });
      acta.addEventListener('click', function (e) {
        var modo = acta.dataset.modo;
        if (modo === 'ritual') return; // el formulario nativo agrega el ritual
        e.preventDefault();
        if (modo === 'nada') return;
        var items = vivos().filter(function (t) { return t.querySelector('input').checked; }).map(function (t) { return { id: +t.dataset.id, quantity: 1 }; });
        acta.disabled = true; acta.textContent = 'Agregando…';
        fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { if (!r.ok) throw r; return r.json(); })
          .then(function () { location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart'; })
          .catch(function () { acta.disabled = false; arma(); msg2('No se pudo agregar. Intenta de nuevo o escríbenos por WhatsApp.'); });
      });
    }
    function msg2(t) { var m = sec.querySelector('[data-uwr-msg]'); if (m) m.textContent = t; }
    arma();

    /* ── barra de compra ── */
    var bar = root.querySelector('[data-uwr-bar]');
    var main = root.querySelector('.uwr-cta button[type=submit], .uwr-cta .add-to-cart-button');
    /* Aparece cuando el botón principal no está a la vista (ya quedó arriba o,
       en teléfono, todavía no llega a la primera pantalla) y se
       oculta mientras el resumen de «Arma el tuyo» está a la vista (ahí ya hay
       un botón). Se mide en cada scroll: una observación por umbrales no se
       entera de un salto largo, como volver arriba de golpe. */
    if (bar && main) {
      var btn = bar.querySelector('button'), was = null, raf = 0;
      var ofr = sec && sec.querySelector('.uwr-arma__o');
      var pie = document.querySelector('.shopify-section-group-footer-group, footer');
      var medir = function () {
        raf = 0;
        var vh = window.innerHeight, m = main.getBoundingClientRect(), on = m.bottom < 0 || m.top > vh;
        if (on && ofr) { var r = ofr.getBoundingClientRect(); if (r.top < vh && r.bottom > 0) on = false; }
        if (on && pie) { if (pie.getBoundingClientRect().top < vh * 0.6) on = false; }
        if (on === was) return; was = on;
        bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (btn) btn.tabIndex = on ? 0 : -1;
      };
      var pedir = function () { if (!raf) raf = requestAnimationFrame(medir); };
      window.addEventListener('scroll', pedir, { passive: true });
      window.addEventListener('resize', pedir);
      medir();
    }
  }
  function all() { document.querySelectorAll('[data-uwr]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
